// Contas Sicoob da Vigor — a parte que não depende de banco.
//
// Eram duas (Associação e Gestão) e a escolha da UC era um sim/não,
// `emitir_em_vigor_gestao`. Em 15/10/2026 entrou a Vigor HSolar e o booleano
// virou `unidades_consumidoras.conta_sicoob`. A lista também vive na tabela
// `contas_sicoob` (migration 20261015201143), que é quem diz se a conta já pode
// emitir. Aqui fica só o que precisa rodar sem I/O, sob `node --test`.

import type { ContaSicoob } from '../../types';

export type { ContaSicoob };

/** Na ordem em que aparecem na tela. */
export const CONTAS_SICOOB: readonly ContaSicoob[] = ['associacao', 'gestao', 'hsolar'];

export const NOME_CONTA_SICOOB: Record<ContaSicoob, string> = {
  associacao: 'Vigor Associação',
  gestao: 'Vigor Gestão',
  hsolar: 'Vigor HSolar',
};

export const isContaSicoob = (v: unknown): v is ContaSicoob =>
  v === 'associacao' || v === 'gestao' || v === 'hsolar';

/**
 * Conta de emissão de uma UC. `conta_sicoob` manda; o booleano antigo só decide
 * quando a coluna não veio no select.
 */
export function contaDaUc(
  uc: { conta_sicoob?: string | null; emitir_em_vigor_gestao?: boolean | null } | null | undefined,
): ContaSicoob {
  const conta = uc?.conta_sicoob;
  if (isContaSicoob(conta)) return conta;
  return uc?.emitir_em_vigor_gestao === true ? 'gestao' : 'associacao';
}

/**
 * Campos de conta no corpo do webhook de EMISSÃO do n8n.
 *
 * - `conta_emissao` é o que o n8n lê para escolher a conta. O corpo leva a fatura
 *   inteira, e o `conta_sicoob` dela é a conta do boleto ANTERIOR (carimbo da
 *   linha digitável) — não serve para decidir onde sai o novo. Por isso o campo
 *   novo, que front antigo nunca manda.
 * - `conta_sicoob` é sobrescrito com a mesma conta, para não chegar ao fluxo um
 *   valor velho contradizendo o novo.
 * - `emitir_em_vigor_gestao` segue junto, coerente, porque o fluxo ainda roteia
 *   Associação x Gestão por ele.
 */
export const camposEmissaoSicoob = (conta: ContaSicoob) => ({
  conta_emissao: conta,
  conta_sicoob: conta,
  emitir_em_vigor_gestao: conta === 'gestao',
});
